import React from 'react';
import PropTypes from 'prop-types';
import styles from './DesktopMenu.module.scss';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { ReactComponent as Harmonogram } from './../../../assets/svg/lawyerMenu/harmonogram.svg';
import { ReactComponent as Cennik } from './../../../assets/svg/lawyerMenu/cennik.svg';
import { ReactComponent as Dokumenty } from './../../../assets/svg/lawyerMenu/dokumenty.svg';
import { ReactComponent as Klienci } from './../../../assets/svg/lawyerMenu/klienci.svg';
import { ReactComponent as Pilne } from './../../../assets/svg/lawyerMenu/pilne.svg';
import { ReactComponent as Polaczenia } from './../../../assets/svg/clientMenu/Polaczenia.svg';
import { ReactComponent as PrzegladPanelu } from './../../../assets/svg/lawyerMenu/przeglad_panelu.svg';
import { ReactComponent as Uslugi } from './../../../assets/svg/lawyerMenu/uslugi.svg';
import { ReactComponent as Wiadomosci } from './../../../assets/svg/lawyerMenu/wiadomosci.svg';
import { ReactComponent as Profil } from './../../../assets/svg/clientMenu/Profil.svg';
import { ReactComponent as HomeIcon } from './../../../assets/svg/home.svg';
import Tooltip from '@material-ui/core/Tooltip';
import { ReactComponent as Dziedziny } from './../../../assets/svg/clientMenu/Dziedziny.svg';
import { ReactComponent as PolaczeniaKlient } from './../../../assets/svg/clientMenu/Polaczenia.svg';

import { ReactComponent as UslugiKlient } from './../../../assets/svg/clientMenu/Uslugi.svg';
import { ReactComponent as Rozliczenia } from './../../../assets/svg/clientMenu/Rozliczenia.svg';

class DesktopMenu extends React.Component<any, any> {
  constructor(props) {
    super(props);

    // this.state = {
    //     completeProfile: false,
    //     completePrices: false
    // }
  }

  shouldDisable = (event = null) => {
    if (window.location.pathname.includes('services/link')) {
      if (event) event.preventDefault();

      return true;
    }

    return false;
  };

  componentDidMount() {
    // this.setState({
    //     completeProfile: this.props.lawyer && this.props.lawyer.description && this.props.lawyer.education && this.props.lawyer.imageId ? true : false,
    //     completePrices: this.props.completePrices ? this.props.completePrices : false
    // })
  }

  render() {
    const completeProfile =
      this.props.lawyer && this.props.lawyer.description && this.props.lawyer.education && this.props.lawyer.imageId ? true : false;
    const completePrices = this.props.completePrices ? this.props.completePrices : false;
    const { user } = this.props;
    if (user && user.role === 'customer')
      return (
        <div
          className={classNames({
            [styles.DesktopMenu]: true,
            [styles.Client]: true,
          })}
        >
          <Link
            to="/"
            className={classNames({
              [styles.single]: true,
              [styles.current]: window.location.pathname == '/' || window.location.pathname.includes('chooselawyer'),
            })}
          >
            <Dziedziny />
            <span>Dziedziny</span>
            <span>Prawa</span>
          </Link>

          <Link
            to="/customer/calls"
            className={classNames({
              [styles.single]: true,
              [styles.current]: window.location.pathname.includes('/customer/calls'),
              [styles.disabled]: false,
            })}
            onClick={(e) => {}}
          >
            <PolaczeniaKlient />
            Połączenia
          </Link>

          <Link
            to="/customer/messages"
            className={classNames({
              [styles.single]: true,
              [styles.current]: window.location.pathname.includes('/customer/messages'),
              [styles.disabled]: false,
            })}
            onClick={(e) => {}}
          >
            <Wiadomosci />
            Wiadomosci
          </Link>

          <Link
            to="/customer/services"
            className={classNames({
              [styles.single]: true,
              [styles.current]: window.location.pathname.includes('/customer/services'),
              [styles.disabled]: false,
            })}
            onClick={(e) => {}}
          >
            <UslugiKlient />
            Usługi
          </Link>

          <Link
            to="/lawyer/schedule"
            className={classNames({
              [styles.single]: true,
              //[styles.current]: window.location.pathname == "/lawyer/schedule",
              [styles.disabled]: true,
            })}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Rozliczenia />
            Rozliczenia
          </Link>

          <Link
            to="/lawyer/prices"
            className={classNames({
              [styles.single]: true,
              //[styles.current]: window.location.pathname == "/lawyer/prices",
              [styles.disabled]: true,
            })}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Profil />
            Profil
          </Link>
        </div>
      );
    else if (user && user.role === 'lawyer')
      return (
        <div className={styles.DesktopMenu}>
          {/* <Tooltip title="Klienci" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/clients"
              className={classNames({
                [styles.single]: true,
                [styles.current]:
                  window.location.pathname.includes("/lawyer/clients"),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Klienci />
            </Link>
          </Tooltip> */}

          <Tooltip title="Usługi" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/services"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/lawyer/services'),
                [styles.disabled]: false,
              })}
              onClick={this.shouldDisable}
            >
              <Uslugi />
              {/*Uslugi*/}
            </Link>
          </Tooltip>

          <Tooltip title="Połączenia" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/calls"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/lawyer/calls'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Polaczenia />
              {/*Połączenia*/}
            </Link>
          </Tooltip>

          <Tooltip title="Wiadomości" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/messages"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/lawyer/messages'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Wiadomosci />
              {/*Wiadomosci*/}
            </Link>
          </Tooltip>

          <Tooltip title="Dokumenty" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/"
              className={classNames({
                [styles.single]: true,
                //[styles.current]: window.location.pathname == "/lawyer/profile"
                [styles.disabled]: true,
              })}
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <Dokumenty />
              {/*Dokumenty*/}
            </Link>
          </Tooltip>

          <Tooltip title="Pilne" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/"
              className={classNames({
                [styles.single]: true,
                //[styles.current]: window.location.pathname == "/lawyer/profile"
                [styles.disabled]: true,
              })}
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <Pilne />
              {/*Pilne*/}
            </Link>
          </Tooltip>

          <Tooltip title="Harmonogram" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/schedule"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/lawyer/schedule'),
                [styles.disabled]: !completeProfile || !completePrices || this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Harmonogram />
              {/*<div>Harmo</div>*/}
              {/*<div>nogram</div>*/}
            </Link>
          </Tooltip>

          <Tooltip title="Cennik" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/prices"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('lawyer/prices'),
                [styles.disabled]: !completeProfile || this.shouldDisable(),
              })}
              onClick={(e) => {
                if (!completeProfile) e.preventDefault();
                else this.shouldDisable(e);
              }}
            >
              <Cennik />
              {/*Cennik*/}
            </Link>
          </Tooltip>

          <Tooltip title="Profil" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/lawyer/profile"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/lawyer/profile'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Profil />
              {/*Profil*/}
            </Link>
          </Tooltip>
        </div>
      );
    else if (user && user.role === 'dealer')
      return (
        <div className={styles.DesktopMenu}>
          <Tooltip title="Strona glówna" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/"
              className={classNames({
                [styles.single]: true,
                [styles.current]: !window.location.pathname.includes('/partner/clients'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <HomeIcon />
            </Link>
          </Tooltip>
          <Tooltip title="Klienci" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/partner/clients"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/partner/clients'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Klienci />
            </Link>
          </Tooltip>
        </div>
      );
    else if (user && user.role === 'secretary')
      return (
        <div className={styles.DesktopMenu}>
          <Tooltip title="Klienci" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/secretary/clients"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/secretary/clients'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Klienci />
            </Link>
          </Tooltip>

          <Tooltip title="Usługi" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/secretary/services"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/secretary/services'),
                [styles.disabled]: false,
              })}
              onClick={this.shouldDisable}
            >
              <Uslugi />
              {/*Uslugi*/}
            </Link>
          </Tooltip>

          <Tooltip title="Połączenia" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/secretary/calls"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/secretary/calls'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Polaczenia />
              {/*Połączenia*/}
            </Link>
          </Tooltip>

          <Tooltip title="Wiadomości" placement="right" arrow enterNextDelay={800}>
            <Link
              to="/secretary/messages"
              className={classNames({
                [styles.single]: true,
                [styles.current]: window.location.pathname.includes('/secretary/messages'),
                [styles.disabled]: this.shouldDisable(),
              })}
              onClick={this.shouldDisable}
            >
              <Wiadomosci />
              {/*Wiadomosci*/}
            </Link>
          </Tooltip>
        </div>
      );
    else return null;
  }
}

DesktopMenu.propTypes = {};

DesktopMenu.defaultProps = {};

export default DesktopMenu;
